var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-contain"},_vm._l((_vm.datalist),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.downLoad(item)}}},[_c('el-image',{staticClass:"elimage",attrs:{"src":_vm.icon1}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }